import { User } from "./user";


export enum Schemes {
    HTTPS = 'https',
    HTTP = 'http',
    WSS = 'wss',
    WS = 'ws'
}

export enum AuthType {
    BASIC = 'basic',
    API_KEY = 'apiKey',
    OAUTH2 = 'oauth2'
}

export enum Oauth2GrantType {
    IMPLICIT = 'implicit',
    PASSWORD = 'password',
    CLIENT_CREDENTIALS = 'clientCredentials',
    AUTHORIZATION_CODE = 'authorizationCode'
}

export enum ObjectType {
    STRING = 'string',
    NUMBER = 'number',
    INTEGER = 'integer',
    BOOLEAN = 'boolean',
    ARRAY = 'array',
    FILE = 'file',
    OBJECT = 'object'
} 

export enum HttpVerb {
    GET = 'GET',
    PUT = 'PUT',
    POST = 'POST',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    HEAD = 'HEAD',
    PATCH = 'PATCH'
}

export enum ParameterLocation {
    QUERY = 'query',
    HEADER = 'header',
    PATH = 'path',
    FORM_DATA = 'formData',
    BODY = 'body'
}

export enum APIKeyLocation {
    QUERY = 'query',
    HEADER = 'header',
}

export enum ArrayJoinMethod {
    CSV = 'csv',
    SSV = 'ssv',
    TSV = 'tsv',
    PIPES = 'pipes',
    MULTI = 'multi'
}

export interface ConnectedApp {
    id?: number;
    name: string;
    description?: string;
    schemes?: Schemes[];
    host: string;
    base_path?: string;

    auths?: ConnectedAppAuth[];
    endpoints: ConnectedAppEndpoint[];
}


export interface ConnectedAppAuth {
    id?: number;
    name: string;
    description?: string;
    type: AuthType;
    api_key_param_name?: string;
    api_key_in?: APIKeyLocation;
    oauth2_grant_type?: Oauth2GrantType;
    oauth2_authorization_url?: string;
    oauth2_token_url?: string;
    oauth2_scopes: ConnectedAppAuthScope[];

    oauth2_client_id?: string;
    oauth2_client_secret?: string;

    connected_app_id?: number;
    connected_app?: ConnectedApp;

    // frontend-only variables
    is_authenticated?: boolean;
}

export interface ConnectedAppEndpoint {
    id?: number;
    url: string;
    http_verb: HttpVerb;
    short_description?: string;
    long_description?: string;
    operation_key: string;
    schemes?: Schemes[];
    accepts: string[];
    returns: string[];
    tags?: string[];
    auth_methods?: ConnectedAppEndpointAuthMethod[][];
    responses: ConnectedAppResponse[];
    parameters?: ConnectedAppParameter[];

    connected_app_id?: number;
}

export interface ConnectedAppResponse {
    id?: number;
    code: string;
    description: string;
    headers?: ConnectedAppResponseHeader[];
    schema?: any;
    examples: any;
}

export interface ConnectedAppParameter {
    id?: number;
    name: string;
    in: ParameterLocation;
    description?: string;
    required?: boolean;
    schema?: any;
    type?: ObjectType;
    format?: string;
    allow_empty_value?: boolean;
    items?: ConnectedAppItemObject;
    items_join_separator?: ArrayJoinMethod;
    default_value: any;
    enum: any[];
}

export interface ConnectedAppAuthScope {
    name: string;
    description?: string;
}

export interface ConnectedAppEndpointAuthMethod {
    auth_name: string;
    scopes?: string[];
}

export interface ConnectedAppResponseHeader {
    name: string;
    type: ObjectType;
    format?: string;
    items?: ConnectedAppItemObject;
    items_join_separator?: ArrayJoinMethod;
    default_value: any;
}

export interface ConnectedAppItemObject {
    type: ObjectType;
    format?: string;
    items?: ConnectedAppItemObject;
    items_join_separator?: ArrayJoinMethod;
    default_value: any;

    description?: string;
    enum: any[];
    example: any;
    required: boolean;
}

export interface ConnectedAppSchemaObject {
    type: ObjectType;
    required?: boolean;
}

export interface ConnectedAppSchemaObjectPrimitive extends ConnectedAppSchemaObject {
    type: ObjectType.BOOLEAN | ObjectType.INTEGER | ObjectType.NUMBER | ObjectType.STRING;
    format?: string;
    description?: string;
    default_value: any;
    enum: any[];
    example: any;
}

export interface ConnectedAppSchemaObjectArray extends ConnectedAppSchemaObject {
    type: ObjectType.ARRAY;
    items: ConnectedAppSchemaObject[];
}

export interface ConnectedAppSchemaObjectObject extends ConnectedAppSchemaObject {
    type: ObjectType.OBJECT;
    properties: ConnectedAppSchemaObjectProperties[];
}

export interface ConnectedAppSchemaObjectProperties {
    name: string;
    schema: ConnectedAppSchemaObject;
}

export interface ConnectedAppActiveAuth {
    id?: number;
    auth_info: any;
    valid_before: string;   // date time
    
    user_id?: number;
    user?: User;

    oauth2_scopes?: string[];

    connected_app_auth?: ConnectedAppAuth;
    connected_app_auth_id: number;
}